import { useAuthContext } from "../../contexts/authContext";
import LoginForm from "../forms/LoginForm";

const HomeFormComponent: React.FC = () => {
  const { isAuthenticated } = useAuthContext();

  return (
    <div className="flex flex-col">
      <div className="pt-16 pb-20 px-4 lg:px-16 bg-gradient-to-r from-orange-600 to-orange-300">
        <h1 className="lg:w-1/2 text-white text-4xl">
          We are here to help you grow your business
        </h1>
      </div>
      <div className="px-4 md:px-0 lg:px-0 mb-8 lg:mr-16 -mt-12 lg:-mt-36 self-center lg:self-end w-full md:w-1/2 lg:w-1/3">
        <div className="w-full p-6 bg-[#FFFFFF] rounded-lg border border-solid border-grey-50">
          <LoginForm disabled={isAuthenticated} />
        </div>
      </div>
      <hr className="h-px mb-4 bg-gray-200 border-0 dark:bg-gray-700"></hr>
    </div>
  );
};

export default HomeFormComponent;
